var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBookmarkLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.15798 18.2118C4.74453 18.5092 4.16797 18.2138 4.16797 17.7044V5.20785C4.16797 3.71207 5.38053 2.49951 6.8763 2.49951H13.125C14.6207 2.49951 15.8333 3.71207 15.8333 5.20785V17.7044C15.8333 18.2138 15.2567 18.5092 14.8433 18.2118L10.0006 14.7277L5.15798 18.2118ZM14.5833 5.20785C14.5833 4.40243 13.9304 3.74951 13.125 3.74951H6.8763C6.07089 3.74951 5.41797 4.40243 5.41797 5.20785V16.4848L9.63562 13.4504C9.85368 13.2935 10.1476 13.2935 10.3656 13.4504L14.5833 16.4848V5.20785Z",
    fill: "#AEB7BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkLine);
export default __webpack_public_path__ + "static/media/icon-bookmark-line.f85b2c271c5d47e8d949df8885a38f5d.svg";
export { ForwardRef as ReactComponent };